





































import Odd from '@core/models/offer/Odd';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import SuperBetsDetails from './SuperBetsDetails.vue';
import OddMultipleButton from './OddMultipleButton.vue';

export default defineComponent({
    name: 'SuperBet',
    props: {
        odd: {
            type: Object as PropType<Odd>,
            required: true,
        },
        isEventLocked: {
            type: Boolean,
            required: true,
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false,
        },
        isResults: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['oddClick'],
    setup(props, { emit }) {
        function onAddClick(e: MouseEvent) {
            if (props.isEventLocked || props.odd.isLocked) {
                return;
            }

            emit('oddClick', e);
        }

        return {
            onAddClick,
        };
    },
    components: {
        SuperBetsDetails,
        OddMultipleButton,
        SdsIcon,
    },
});
